import { useSearchParams } from '@remix-run/react'
import { Flex, Form, Input } from 'antd'
import React, { useEffect } from 'react'
import { DesignSystem } from '~/core/designSystem'
import { FormClient } from '~/plugins/form/client'
import { useSettingsContext } from './contex'

export const UpdateModal: React.FC = () => {
  const { settings, isFetched, refetch } = useSettingsContext()

  const [searchParams, setSearchParams] = useSearchParams()

  const form = FormClient.useForModel({
    modelName: 'Settings',
    onCancel: () => {
      searchParams.delete('settings')
      setSearchParams(searchParams)
      refetch()
    },
  })

  const isSettings = searchParams.get('settings')

  useEffect(() => {
    if (isFetched) {
      if (isSettings) {
        form.start({ where: settings ? { id: settings?.id } : undefined })
      }
    }
  }, [isSettings, isFetched])

  return (
    <>
      <form.FormView>
        <Form.Item label="Preview base url" name="url">
          <Input placeholder="http://localhost:8099" />
        </Form.Item>

        <Form.Item label="App local path" name="pathSource">
          <Input placeholder="/Users/yourname/Documents/projects/marblism/yourapp" />
        </Form.Item>

        <Flex className="mb-5">
          <Form.Item label="Theme">
            <DesignSystem.ThemeToggle />
          </Form.Item>
        </Flex>
      </form.FormView>
    </>
  )
}
